module.exports = __webpack_public_path__ + "img/bg_noContent.ebf9325f.png";